export Tabs from './Tabs';

export FooterMenu from './FooterMenu';

export Menu from './Menu';
export News from './News';
export Weather from './Weather';

export InputFlow from './Game/InputFlow';
export ElevatorField from './Game/ElevatorField';
export OutputFlow from './Game/OutputFlow';
export Requests from './Game/Requests';
export PathPopup from './PathPopup';
export Plan from './Game/Plan';
export FinanceData from './Game/FinanceData';



// WEBPACK FOOTER //
// ./src/shared/components/index.js